/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, List, Segment, Grid } from 'semantic-ui-react';
import { map } from 'lodash';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers';
import { Logo } from '@plone/volto/components';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );

  return (
    <div id="footer">
      <Container>
        <div id="footer-main">
          <Grid textAlign="left" columns={3}>
            <Grid.Column>
              <List>
                <List.Content>
                  <List.Item>
                    <UniversalLink href="/aboutus">Über uns</UniversalLink>
                  </List.Item>
                </List.Content>
              </List>
            </Grid.Column>
            <Grid.Column>
              <List>
                <List.Content>
                  <List.Item>
                    <UniversalLink href="https://www.dlr.de/de">
                      DLR Main Page
                    </UniversalLink>
                  </List.Item>
                  <List.Item>
                    <UniversalLink href="https://transformations-hub-miamy.de/">
                      Transformation Hub Miamy
                    </UniversalLink>
                  </List.Item>
                </List.Content>
              </List>
            </Grid.Column>
            <Grid.Column className="separated">
              <List>
                <List.Content>
                  <List.Item>
                    <UniversalLink href="/barrierefreiheit">Barrierefreiheit</UniversalLink>
                  </List.Item>
                  <List.Item>
                    <UniversalLink href="/datenschutz">Datenschutzerklärung</UniversalLink>
                  </List.Item>
                  <List.Item>
                    <UniversalLink href="/cookies">Datenschutz-Einstellungen (Cookies)</UniversalLink>
                  </List.Item>
                  <List.Item>
                    <UniversalLink href="/impressum">Impressum & Nutzungsbedingungen</UniversalLink>
                  </List.Item>
                </List.Content>
              </List>
            </Grid.Column>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
